import { Component, Input } from "@angular/core";

@Component({
    selector: "app-account-export",
    templateUrl: "./export-csv.component.html",
    styleUrls: ["./export-csv.component.scss"],
})
export class ExportCSVComponent {
    @Input() isLink = false;
    @Input() public config: {
        columns: Record<string, string>;
        rows: any[];
        dataType: string;
    };

    private fileName: string;
    private columnsToDisplay: string[];
    private columnProps: string[];

    get hasData() {
        return this.config.rows?.length;
    }

    exportCSV() {
        this.fileName = (this.config.dataType ? this.config.dataType : "Export") + ".csv";
        this.columnsToDisplay = Object.values(this.config.columns);
        this.columnProps = Object.keys(this.config.columns);
        const csvFile = this.processRows();
        const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        if (link.download !== undefined) {
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", this.fileName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    compileRowData(cellData, isStatusColumn = false) {
        let innerValue = !!cellData ? cellData.toString() : "";

        if (cellData instanceof Date) {
            innerValue = cellData.toLocaleString();
        } else if (isStatusColumn && cellData) {
            innerValue = cellData[0].toString();
        }

        //innerValue = innerValue.replaceAll(/"/g, `\"`);
        innerValue = innerValue.replaceAll(/\"/g, `"\"`);

        if (innerValue.search(/('|,|\n)/g) >= 0) {
            innerValue = `"` + innerValue + `"`;
        }

        innerValue += ",";

        return innerValue;
    }

    processRows() {
        let finalVal = this.columnsToDisplay.join(",") + "\n";
        this.config.rows?.forEach((value: any) => {
            const reducer = (rowString, row) => rowString + this.compileRowData(value[row], row.includes("Status"));
            finalVal += this.columnProps.reduce(reducer, "").replace(/,\s*$/, "") + "\n";
        });
        return finalVal;
    }
}
